<template>
  <div class="container main">
    <div class="row">
      <div class="col-md-12">
        <SectionTitle
          title="Desempenho Geral"
          description="Desempenho das equipes do município"
          url="/desempenho-por-equipe"
          modalDocumento="Geral"
        />
      </div>
      <div class="col-lg-4">
        <vue-select
          :options="optionsPeriodos"
          label="label"
          placeholder="PERÍODO"
          @input="onChangePeriodo"
          v-model="periodo"
          class="my-2"
          style="background-color: #fff"
        >
          <template slot="option" slot-scope="option">
            {{ option.label }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
      <div class="col-lg-4">
        <vue-select
          :options="options2"
          label="label"
          placeholder="RESULTADO"
          @input="onChangeSelect2"
          v-model="selected2"
          class="my-2"
          style="background-color: #fff"
        >
          <template slot="option" slot-scope="option">
            {{ option.label }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
      <div class="col-lg-4">
        <vue-select
          :options="options"
          label="label"
          placeholder="CLASSIFICAR POR"
          @input="onChangeSelect"
          v-model="selected"
          class="my-2"
          style="background-color: #fff"
        >
          <template slot="option" slot-scope="option">
            {{ option.label }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <download-excel
          :data="equipes"
          :fields="fields"
          worksheet="My Worksheet"
          name="desempenho-geral.xls"
          class="btn-xls"
        >
          <i class="icofont-file-excel"></i> XLS
        </download-excel>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 mt-3">
        <tabela-cadastros-vuetfy
          :cadastros="equipes"
          :loading="loading"
        ></tabela-cadastros-vuetfy>
      </div>
      <div class="col-lg-12" style="font-size: 15px">
        <strong>Fonte:</strong>{{ _descriptionEsus }}
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from './SectionTitle'
import TabelaCadastrosVuetfy from './TabelaCadastrosVuetfy.vue'

export default {
  components: {
    SectionTitle,
    TabelaCadastrosVuetfy,
  },
  data() {
    return {
      cod_ibge: '',
      equipes: [],
      loading: false,
      size: '40px',
      color: '#0D98BB',
      ultimoQuadrimestre: '',
      options: [
        {
          label: 'ISFE',
          value: 'isfe',
        },
        {
          label: 'DESEMPENHO',
          value: 'desempenho',
        },
      ],
      options2: [
        {
          label: 'PREVISÃO',
          value: 'previsao',
        },
        {
          label: 'DEFINITIVO',
          value: 'definitivo',
        },
      ],
      optionsPeriodos: [
        // {
        //   label: '4/2022',
        //   value: '4/2022'
        // },
        // {
        //   label: '5/2022',
        //   value: '5/2022'
        // },
        // {
        //   label: '6/2022',
        //   value: '6/2022'
        // },
        // {
        //   label: '7/2022',
        //   value: '7/2022'
        // },
        // {
        //   label: '8/2022',
        //   value: '8/2022'
        // },
        // {
        //   label: '9/2022',
        //   value: '9/2022'
        // },
        // {
        //   label: '10/2022',
        //   value: '10/2022'
        // }
      ],
      selected: '',
      selected2: '',
      periodo: '',
      fonte: '',
      tituloColunaQuadrimestre: '',
      fields: {
        'NOME DA EQUIPE': {
          field: 'no_equipe',
        },
        INE: {
          field: 'nu_ine',
          callback: (value) => {
            return value !== '' ? `​  ​​${value.toString()}` : ''
          },
        },
        'Pré-Natal (6 consultas) (%)': 'pn_6_consultas_resultado',
        'Pré-Natal (Sífilis e HIV) (%)': 'pn_hiv_sifilis_resultado',
        'Gestantes Saúde Bucal (%)': 'pn_odontologia_resultado',
        'Cobertura Citopatológico (%)': 'citopatologico_resultado',
        'Cobertura Polio e Penta (%)': 'crianca_polio_penta_resultado',
        'Hipertensão (PA Aferida) (%)': 'pa_hipertensao_resultado',
        'Diabetes (Hemoglobina Glicada) (%)': 'hg_diabetes_resultado',
        ISFE: 'isfe',
        DESEMPENHO: 'desempenho',
        PERÍODO: {
          field: 'quadrimestre',
          callback: (value) => {
            return value !== '' ? ` ${value.toString()}` : ''
          },
        },
      },
    }
  },
  created() {
    this.init()
  },
  computed: {
    _descriptionEsus() {
      if (this.selected2.value === 'previsao') {
        return ` e-SUS PEC, ${this._ultimaAtualizacao}`
      }
      return ` SISAB, ${this.ultimoQuadrimestre}`
    },
    _ultimaAtualizacao() {
      let date = ''
      if (this.$store.getters['getUltimaAtualizacao'] !== null) {
        date = this.$store.getters['getUltimaAtualizacao']
      }
      return date
    },
  },
  methods: {
    onChangeSelect(event) {
      switch (event.value) {
        case 'desempenho':
          this.ordenar('desempenho')
          break
        case 'isfe':
          this.ordenar('isfe')
          break
        default:
          break
      }
    },

    onChangeSelect2(event) {
      switch (event.value) {
        case 'previsao':
          this.buscarDesempenhoGeralPrevisao()
          break
        case 'definitivo':
          this.periodo = null
          this.buscarDesempenhoGeral()
          break
        default:
          break
      }
    },

    onChangePeriodo(item) {
      this.$api
        .get(
          '/app/desempenho-por-equipe/' +
            this.cod_ibge +
            '/geral/previsao/' +
            item.value.replace('/', '-')
        )
        .then((response) => {
          this.ultimoQuadrimestre = response.data[0].quadrimestre
          this.equipes = response.data
          this.selected = this.options.find((item) => item.value === 'isfe')
          this.ordenar('isfe')
          this.loading = false
          this.selected2 = {
            label: 'PREVISÃO',
            value: 'previsao',
          }
          this.onChangeSelect2({ value: 'previsao' })
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    buscarDesempenhoGeralPrevisao() {
      this.loading = true
      this.tituloColunaQuadrimestre = 'Mês'
      this.fonte = 'e-SUS PEC'
      let mesAno = ''
      if (this.periodo === '' || this.periodo === null) {
        // busca o maior
        const respMesAno = this.optionsPeriodos.reduce(function (
          prev,
          current
        ) {
          let value1 = prev.value.split('/')
          let value2 = current.value.split('/')
          return Number(value1[0]) < Number(value2[0]) ? current : prev
        })
        mesAno = this.optionsPeriodos[0].value
        this.periodo = this.optionsPeriodos[0].value
      } else {
        mesAno = this.periodo.value
      }
      this.$api
        .get(
          '/app/desempenho-por-equipe/' +
            this.cod_ibge +
            '/geral/previsao/' +
            mesAno.replace('/', '-')
        )
        .then((response) => {
          this.ultimoQuadrimestre = response.data[0].quadrimestre
          this.equipes = response.data
          this.selected = this.options.find((item) => item.value === 'isfe')
          this.ordenar('isfe')
          this.loading = false
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    ordenar(prop) {
      const sortArray = this.equipes.sort(function (a, b) {
        // Se o ise for igual, ordena pelo desempenho
        if (prop === 'isfe') {
          if (Number(a.isfe) === Number(b.isfe)) {
            if (Number(a.desempenho) < Number(b.desempenho)) return 1
            if (Number(a.desempenho) > Number(b.desempenho)) return -1
            return 0
          } else {
            if (Number(a[prop]) < Number(b[prop])) return 1
            if (Number(a[prop]) > Number(b[prop])) return -1
            return 0
          }
        } else {
          if (Number(a[prop]) < Number(b[prop])) return 1
          if (Number(a[prop]) > Number(b[prop])) return -1
          return 0
        }
      })
      this.equipes = sortArray
    },

    buscarDesempenhoGeral() {
      this.loading = true
      this.tituloColunaQuadrimestre = 'Quadrimestre'
      this.fonte = 'SISAB'
      this.$api
        .get('/app/desempenho-por-equipe/' + this.cod_ibge + '/geral')
        .then((response) => {
          this.ultimoQuadrimestre = response.data[0].quadrimestre
          this.equipes = response.data
          this.selected = this.options.find((item) => item.value === 'isfe')
          this.ordenar('isfe')
          this.loading = false
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    indicadorColor(percentual, indicador) {
      switch (indicador) {
        case 'pre-natal':
          if (percentual < 45) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        case 'hiv-sifilis':
          if (percentual < 60) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        case 'consultas-odontologicas':
          if (percentual < 60) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        case 'citopatologico':
          if (percentual < 40) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        case 'polio-penta':
          if (percentual < 95) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        case 'hipertensao':
          if (percentual < 50) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        case 'hemoglobina-glicada':
          if (percentual < 50) {
            return 'indicador-red'
          } else {
            return 'indicador-blue'
          }
          break
        default:
          break
      }
    },

    async buscarPeriodos() {
      try {
        const response = await this.$api.get(
          '/app/desempenho-por-equipe/' + this.cod_ibge + '/periodos'
        )
        if (response) {
          this.optionsPeriodos = response.data.map((item) => {
            return {
              label: item.periodo,
              value: item.periodo,
            }
          })
        }
      } catch (error) {
        console.log(error)
      }
    },

    async init() {
      this.cod_ibge = this.$store.state.cod_ibge
      await this.buscarPeriodos()
      await this.buscarDesempenhoGeralPrevisao()
      this.selected2 = this.options2.find((item) => item.value === 'previsao')
      this.selected = this.options.find((item) => item.value === 'isfe')
    },
  },
}
</script>

<style>
.indicador-red {
  color: red;
}

.indicador-orange {
  color: orange;
}

.indicador-green {
  color: green;
}

.indicador-blue {
  color: blue;
}

.btn-xls {
  width: 85px;
  color: #fff;
  background-color: #545b62;
  border-color: #4e555b;
  padding: 6px;
  border-radius: 30px;
  text-align: center;
  cursor: pointer;
  margin-top: 5px;
}
</style>
